import { Link } from "react-router-dom";
import RoutesConst from "../../consts/RoutesConst.js";
import logo from "../../assets/logo/logoNav.png";
import GeneralStrings from "../../strings/GeneralStrings.json";

const NAVBAR_STRINGS = GeneralStrings.NAVBAR;

export const loginItems = (
  <Link to={RoutesConst.LOGIN} className="logo-link">
    <img src={logo} alt="Logo" className="navbar-logo" />
    {/*<span className="logo-text">{GeneralStrings.MAKE_A_WAVE}</span>*/}
  </Link>
);

export const navbarItems = (
  <>
    <Link to={RoutesConst.DEFAULT} className="nav-link">
      {NAVBAR_STRINGS.HOME}
    </Link>
    <Link to={RoutesConst.SERVICES} className="nav-link">
      {NAVBAR_STRINGS.SERVICES}
    </Link>
    <Link to={RoutesConst.SERVICE_AREA} className="nav-link">
      {NAVBAR_STRINGS.SERVICE_AREA}
    </Link>
    <Link to={RoutesConst.ENROLL} className="nav-link">
      {NAVBAR_STRINGS.ENROLL}
    </Link>
    <Link to={RoutesConst.LIFEGUARDS} className="nav-link">
      {NAVBAR_STRINGS.LIFEGUARDS}
    </Link>
    {/*     <Link to={RoutesConst.INSTRUCTORS} className="nav-link">
      {NAVBAR_STRINGS.BECOME_AN_INSTRUCTOR}
    </Link> */}
    <Link to={RoutesConst.ABOUT_US} className="nav-link">
      {NAVBAR_STRINGS.ABOUT_US}
    </Link>
    <Link to={RoutesConst.REVIEWS} className="nav-link">
      {NAVBAR_STRINGS.REVIEWS}
    </Link>
  </>
);

export const socialItems = (
  <>
    <Link
      to="https://www.instagram.com/swimlessonsorlando/"
      target="_blank"
      className="nav-social-link"
    >
      <i className="fa-brands fa-instagram social-icon"></i>
    </Link>
    <Link
      to="https://www.facebook.com/profile.php?id=61574990496375"
      target="_blank"
      className="nav-social-link"
    >
      <i className="fa-brands fa-facebook-square social-icon"></i>
    </Link>
  </>
);
